import {useState, React, useEffect } from 'react'
import { Byline, Published } from "../"
import { collection, getDocs, query, where, addDoc } from 'firebase/firestore';
import { db, auth, app, storage, database } from '../../../setup/Firebase';
import { getDatabase, ref, set, child, get, onValue } from "firebase/database";
import { getStorage, getDownloadURL, ref as storageRef } from 'firebase/storage'
import "./articles.css"
import { getAuth } from 'firebase/auth';
import { useAuth } from '../../../setup/AuthContext';
import { ReactGAImplementation } from 'react-ga4';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

function useTrackPageViews() {
  let location = useLocation();
  useEffect(() => {
  // Track page view with react-ga4
  ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
  }, [location]);
  }

export default function PremiumArticle(props) { 

  useTrackPageViews();  
  
  function Title({ value }) {
        return <h1>{value}</h1>;
  }
    
  function Image({ url }) {
    const [images, setImages] = useState();

    useEffect(() => {
        const fetchImages = async () => {
            try {
                const result = await getDownloadURL(storageRef(storage, url));
                console.log(result);
                setImages(result);
            } catch (error) {
                console.error('Error getting url', error);
                // Handle error gracefully, e.g., display an error message to the user
            }
        };

        fetchImages(); // Call fetchImages inside useEffect
    }, []); // Empty dependency array ensures the effect runs only once on initial render

      return <img src={images} alt="image" />;
  }

  function Pdf({ url, value }) {
    const [pdf, setPdf] = useState();

    useEffect(() => {
        const fetchPdf = async () => {
            try {
                const result = await getDownloadURL(storageRef(storage, url));
                console.log(result);
                setPdf(result);
            } catch (error) {
                console.error('Error getting url', error);
                // Handle error gracefully, e.g., display an error message to the user
            }
        };

        fetchPdf(); // Call fetchImages inside useEffect
    }, []); // Empty dependency array ensures the effect runs only once on initial render

      return <a href={pdf} target="_blank">{value}</a>;
  }

  function Text({ value }) {
    return <p>{value}</p>;
    }
  
  function Head({ value }) {
    return <h2>{value}</h2>;
    }

  function Date({ value }) {
    return <i>{value}</i>;
    }
  
  function Link({ url, text }) {
    return <a href={url}>{text}</a>;
  }

  function LinkBetween({ url, text }) {
    return <a href={url}> {text} </a>;
  }

  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


    // const Article = {
    //   title: "",
    //   date: "",
    //   content: [
    //     { type: "text", value: "" },
    //     { type: "text", value: "" },
    //     { type: "text", value: "" },
    //     { type: "image", url: ".jpeg", alt: "" }, 
    //     { type: "image", url: ".jpeg", alt: "" }, 
    //     { type: "text", value: "" },
    //     { type: "link", url: "", text: "" },
    //     { type: "text", value: "" }
    //   ]
    // };


    // function writeUserData() {
    //     set(ref(database, 'premium/' + 'article16'), Article);
    //   }
    //   writeUserData()

   
    
 
    
   
    

    useEffect(() => {

        
        const unsubscribe = onValue(ref(database, `/premium/${props.article}`), (snapshot) => {
          
          if (snapshot.exists()) {
            setData(snapshot.val());
          } else {
            console.error("Document not found or access denied.");
          }
        }, (error) => {
          console.error("Error reading document:", error);
        });
    
        // Cleanup function to unsubscribe when component unmounts
        return () => unsubscribe();
        
      }, []); 
    
    
    return (
      <div className='emas__article1'>
        <div className='emas__articles-container'>
            <img className="emas__articles-container_headImage" src={`../../../assets/images/articles/${props.headerImage}`} alt={props.headerImage}/>
            <div className='emas__articles-container_photo'>
              {/* <i>Photo by: {props.photographer}: {props.reference}</i> */}
            </div>
            {data && <Title value={data.title}/>}
            {/* <Byline /> */}
            <div className='emas__articles-container_publish'>
              {data && <Date value={data.date}/>}
            </div>
            <div className='emas__articles-container_body'>
            {data && data.content.map((element, index, array) => {
              const previousElement = index > 0 ? array[index - 1] : null;
              const nextElement = index < array.length - 1 ? array[index + 1] : null;
              const secondNextElement = index < array.length - 1 ? array[index + 2] : null;
              // Render link between text elements
              if (element.type === 'text' && nextElement && nextElement.type === 'link') {
                return (
                  <p key={index}>
                    {element.value}
                    <LinkBetween url={nextElement.url} text={nextElement.text} />
                    {secondNextElement.value}
                  </p>
                );
              }

              // Skip the next element if it's a link
              if (nextElement && nextElement.type === "link") {
                return null; // Skip rendering the next element
              }
              if (previousElement && previousElement.type === "link") {
                return null; // Skip rendering the next element
              }
              // Render other types of elements
              if (element.type === 'text') {
                return <Text key={element.value} value={element.value} />;
              
              } else if (element.type === 'image') {
                return <Image key={element.url} url={element.url} alt={element.alt}/>;
              } else if (element.type === 'pdf') {
                return <Pdf key={element.url} url={element.url} value={element.value}/>;
              } else if (element.type === 'head') {
                return <Head key={element.value} value={element.value} />;
              }
              return null; // Handle other types if needed
            })}
            </div>
            <Published />
        </div>
      </div>
    )
  }




